import {useEventBus} from "../../../assets-dev/ts/modules/use-event-bus";

const enum CollapseState {
    Closed = 'closed',
    Open = 'open',
}

export class ComponentCategories {
    private readonly openClass = 'expanded';
    private readonly itemClass = '.hd-categories__items';
    private readonly toggleElClass = '.hd-categories__all';
    private readonly contentWrapperClass = '.hd-collapse__item-content-wrapper';
    private readonly itemContentClass = '.hd-collapse__item-content';

    private el: HTMLElement;
    private item: HTMLElement | null;
    private toggleEl: HTMLElement | null;
    private contentWrapper: HTMLElement | null;
    private content: HTMLElement | null;
    private state: CollapseState;
    private alwaysOpen: boolean;

    private clickEventFn;
    private resizeEventFn;

    constructor(el: HTMLElement) {
        this.el = el;
        this.item = el.querySelector(this.itemClass);
        this.toggleEl = el.querySelector(this.toggleElClass);
        this.contentWrapper = el.querySelector(this.contentWrapperClass);
        this.content = el.querySelector(this.itemContentClass);
        this.state = this.toggleEl && this.toggleEl.getAttribute('aria-expanded') === 'false' ? CollapseState.Closed : CollapseState.Open;
        this.alwaysOpen = !this.toggleEl;
    }

    public onInit() {
        if (this.toggleEl) {
            this.clickEventFn = this.toggle.bind(this);
            this.toggleEl.addEventListener('click', this.clickEventFn);

            this.resizeEventFn = this.onResize.bind(this);
            window.addEventListener('resize', this.resizeEventFn);
        } else {
            this.open();
        }
    }

    public onDestroy() {
        if (this.clickEventFn && this.toggleEl) {
            this.toggleEl.removeEventListener('click', this.clickEventFn);
        }
        if (this.resizeEventFn) {
            window.removeEventListener('resize', this.resizeEventFn);
        }
    }

    private onResize() {
        if (this.alwaysOpen) {
            return;
        }
        if (this.state === CollapseState.Open) {
            this.setHeight();
        }
    }

    private toggle() {
        this.state === CollapseState.Open ? this.close() : this.open();
    }

    private open() {
        this.state = CollapseState.Open;
        if (this.item) {
            this.item.classList.add(this.openClass);
        }
        if (this.toggleEl) {
            this.toggleEl.setAttribute('aria-expanded', 'true');
        }
        if (this.contentWrapper && this.content) {
            if (this.alwaysOpen) {
                this.contentWrapper.style.height = `auto`;
            } else {
                this.setHeight();
            }
        }
    }

    private close() {
        this.state = CollapseState.Closed;
        if (this.item) {
            this.item.classList.remove(this.openClass);
        }
        if (this.contentWrapper && this.content) {
            this.contentWrapper.style.height = `0`;
        }
    }

    private setHeight() {
        if (this.contentWrapper && this.content) {
            const height = this.content.getBoundingClientRect().height;
            this.contentWrapper.style.height = `${height}px`;
        }
    }

}

export function useComponentCategories() {
    useEventBus('hd-categories', ComponentCategories);
}